<div class="mfa-method-disabled">
	<div class="notification-content">
		<mat-icon class="warning-icon">warning</mat-icon>
		<h2>Your MFA method is no longer available</h2>

		<p class="body-text">
			Your administrator has changed the permitted authentication methods.
			Your enrolled method ({{ disabledMethodDisplayNames }}) is no longer available to use for sign-in.
			<span *ngIf="hasAvailableMethods">Please set up a new authentication method to continue.</span>
		</p>

		<p *ngIf="isEnforced && data.gracePeriodActive && data.gracePeriodDaysRemaining != null"
		   class="grace-period-text">
			You have {{ data.gracePeriodDaysRemaining }} day{{ data.gracePeriodDaysRemaining !== 1 ? 's' : '' }}
			remaining to set up a new method before access to the portal is restricted.
		</p>

		<div class="actions">
			<button mat-raised-button
					color="primary"
					*ngIf="hasAvailableMethods"
					(click)="setupNewMethod()">
				Set up a new method
			</button>

			<!-- F-158: keyboard-reachable — inside a disableClose modal with Escape off, this is the only way an
			     Optional-policy user reaches the portal without enrolling, so it must not be mouse-only. -->
			<a *ngIf="isOptional"
			   class="continue-link"
			   tabindex="0"
			   role="button"
			   (click)="continueToPortal()"
			   (keydown.enter)="continueToPortal()"
			   (keydown.space)="continueToPortal()">
				Continue to portal
			</a>

			<!-- F-132: always available, so an Enforced user with no enrollable method is never trapped. -->
			<button mat-stroked-button
					class="sign-out-button"
					(click)="signOut()">
				Sign out
			</button>
		</div>

		<div *ngIf="!hasAvailableMethods" class="no-methods-notice">
			<p>No authentication methods are currently available. Please contact your administrator for assistance.</p>

			<div class="contact-info" *ngIf="data.contactAdminPhone || data.contactAdminEmail">
				<div class="contact-item" *ngIf="data.contactAdminPhone">
					<mat-icon>phone</mat-icon>
					<span>{{ data.contactAdminPhone }}</span>
				</div>
				<div class="contact-item" *ngIf="data.contactAdminEmail">
					<mat-icon>email</mat-icon>
					<a [href]="'mailto:' + data.contactAdminEmail">{{ data.contactAdminEmail }}</a>
				</div>
			</div>
		</div>
	</div>
</div>
